import SalesAdvertisingMonthlyReport from './salesAdvertisingMonthlyReport';

export default SalesAdvertisingMonthlyReport;
